/* BRANDSETS – ulubione bez konta (v43)
   Lista ulubionych (uchwyty produktów) zapisana w przeglądarce klienta (localStorage, klucz bs_ulubione_v1),
   więc zostaje po zamknięciu strony – bez logowania. Skrypt:
   - dokłada serduszko na kafelkach produktów (product-card) i obok nazwy na stronie produktu,
   - dokłada ikonę serca z licznikiem w nagłówku (link do /pages/ulubione),
   - na stronie /pages/ulubione (sekcja bs-wishlist) rysuje listę zapisanych produktów.
   Wygląd: assets/bs-wishlist.css. Dołączony w snippets/bs-header-style.liquid. */
(function () {
  if (window.__bsWl) return;
  window.__bsWl = true;

  var KEY = 'bs_ulubione_v1';
  var MAX = 60;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var PAGE = root + 'pages/ulubione';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.2l-1.15-1.05C6.2 14.95 3.2 12.2 3.2 8.85 3.2 6.15 5.3 4.1 7.95 4.1c1.5 0 2.95.7 4.05 1.85C13.1 4.8 14.55 4.1 16.05 4.1c2.65 0 4.75 2.05 4.75 4.75 0 3.35-3 6.1-7.65 10.3L12 20.2z"/></svg>';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (x) { return typeof x === 'string' && x; }) : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
    sync();
    document.dispatchEvent(new CustomEvent('bs:wishlist', { detail: list }));
  }
  function has(h) { return read().indexOf(h) > -1; }
  function toggle(h) {
    var list = read();
    var i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.unshift(h);
    write(list);
    return i === -1;
  }
  function handleFrom(href) {
    var m = (href || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function setState(b) {
    var on = has(b.getAttribute('data-bs-wl'));
    b.classList.toggle('is-on', on);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.setAttribute('aria-label', on ? 'Usuń z ulubionych' : 'Dodaj do ulubionych');
  }
  function makeBtn(h, cls) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'bs-wl-btn ' + cls;
    b.setAttribute('data-bs-wl', h);
    b.innerHTML = HEART;
    setState(b);
    return b;
  }

  function header() {
    var ul = document.querySelector('.header__utils-items');
    if (!ul) return;
    var li = ul.querySelector('.bs-wl-hd');
    if (!li) {
      li = document.createElement('li');
      li.className = 'header__utils-item header__utils-item--mobile bs-wl-hd';
      // (v44) ten sam układ co ikona koszyka (header__utils-link + icon-with-text), żeby serce stało w jednej linii z koszykiem
      li.innerHTML = '<a href="' + PAGE + '" class="header__utils-link text--link bs-wl-hd__link" title="Ulubione" aria-label="Ulubione">' +
        '<div class="icon-with-text header__utils-link--icon"><span class="icon">' + HEART + '</span></div>' +
        '<span class="bs-wl-hd__count" hidden></span></a>';
      ul.insertBefore(li, ul.querySelector('.header__utils-item--cart'));
    }
    var n = read().length;
    var c = li.querySelector('.bs-wl-hd__count');
    if (c.textContent !== String(n)) c.textContent = String(n);
    c.hidden = n === 0;
  }

  /* (v46) Blog w pasku ikon na komputerze – przed „Moje konto”, ikona kartki + podpis „Blog”.
     Pozycja bez klasy header__utils-item--mobile, więc na telefonie jej nie ma (tam Blog jest w menu). */
  var BLOG_ICON = '<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
    '<path d="M6 3.75H14.25L18 7.5V20.25H6V3.75Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="square"/>' +
    '<path d="M14 4V7.75H17.75" stroke="currentColor" stroke-width="1.5" stroke-linejoin="square"/>' +
    '<path d="M9 11.5H15M9 14.5H15M9 17.5H12.5" stroke="currentColor" stroke-width="1.5"/></svg>';
  function blog() {
    var ul = document.querySelector('.header__utils-items');
    if (!ul || ul.querySelector('.bs-blog-hd')) return;
    var before = ul.querySelector('.header__utils-item--account') || ul.querySelector('.bs-wl-hd') || ul.querySelector('.header__utils-item--cart');
    if (!before) return;
    var li = document.createElement('li');
    li.className = 'header__utils-item bs-blog-hd';
    li.innerHTML = '<a href="' + root + 'blogs/aktualnosci" class="header__utils-link text--link" title="Blog">' +
      '<div class="icon-with-text header__utils-link--icon"><span class="icon">' + BLOG_ICON + '</span>' +
      '<span class="icon__text">Blog</span></div></a>';
    ul.insertBefore(li, before);
  }

  function decorate() {
    var cards = document.querySelectorAll('product-card.product-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.querySelector('.bs-wl-btn')) continue;
      var box = card.querySelector('.product-card__actions');
      var a = card.querySelector('a[href*="/products/"]');
      var h = a && handleFrom(a.getAttribute('href'));
      if (box && h) box.appendChild(makeBtn(h, 'bs-wl-btn--card'));
    }
    var t = document.querySelector('.product__title');
    if (t && !document.querySelector('.bs-wl-btn--pdp')) {
      var ph = handleFrom(location.pathname);
      if (ph) {
        var row = document.createElement('div');
        row.className = 'bs-wl-titlerow';
        t.parentNode.insertBefore(row, t);
        row.appendChild(t);
        row.appendChild(makeBtn(ph, 'bs-wl-btn--pdp'));
      }
    }
    header();
    blog();
  }

  function sync() {
    var all = document.querySelectorAll('.bs-wl-btn');
    for (var i = 0; i < all.length; i++) setState(all[i]);
    header();
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.bs-wl-btn');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var on = toggle(b.getAttribute('data-bs-wl'));
    if (on) {
      b.classList.remove('is-pop');
      void b.offsetWidth;
      b.classList.add('is-pop');
    }
  }, true);

  window.addEventListener('storage', function (e) { if (e.key === KEY) { sync(); renderPage(); } });

  /* strona „Ulubione” */
  var cache = {};
  function money(cents) {
    return (cents / 100).toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' zł';
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function fetchProduct(h) {
    if (!cache[h]) {
      cache[h] = fetch(root + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[h];
  }
  function card(p, h) {
    var img = p.featured_image ? (p.featured_image.indexOf('?') > -1 ? p.featured_image + '&width=600' : p.featured_image + '?width=600') : '';
    var sale = p.compare_at_price && p.compare_at_price > p.price;
    return '<li class="bs-wl-item">' +
      '<div class="bs-wl-item__media">' +
        '<a href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<button type="button" class="bs-wl-btn bs-wl-btn--card is-on" data-bs-wl="' + esc(h) + '" aria-pressed="true" aria-label="Usuń z ulubionych">' + HEART + '</button>' +
        (p.available ? '' : '<span class="bs-wl-item__out">Wyprzedane</span>') +
      '</div>' +
      '<a class="bs-wl-item__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<div class="bs-wl-item__price">' + (sale ? '<span class="is-sale">' + money(p.price) + '</span> <del>' + money(p.compare_at_price) + '</del>' : money(p.price)) + '</div>' +
    '</li>';
  }
  var renderToken = 0;
  function renderPage() {
    var page = document.querySelector('[data-bs-wl-page]');
    if (!page) return;
    var grid = page.querySelector('.bs-wl-grid');
    var empty = page.querySelector('.bs-wl-empty');
    var count = page.querySelector('.bs-wl-page__count');
    var list = read();
    var token = ++renderToken;
    if (!list.length) {
      grid.innerHTML = '';
      empty.hidden = false;
      if (count) count.textContent = '';
      page.classList.remove('is-loading');
      return;
    }
    empty.hidden = true;
    page.classList.add('is-loading');
    Promise.all(list.map(fetchProduct)).then(function (items) {
      if (token !== renderToken) return;
      var html = '';
      var missing = [];
      items.forEach(function (p, i) {
        if (p) html += card(p, list[i]); else missing.push(list[i]);
      });
      grid.innerHTML = html;
      var n = list.length - missing.length;
      if (count) count.textContent = n === 1 ? '1 produkt' : n + (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14) ? ' produkty' : ' produktów');
      empty.hidden = n > 0;
      page.classList.remove('is-loading');
      if (missing.length) {
        try { localStorage.setItem(KEY, JSON.stringify(list.filter(function (h) { return missing.indexOf(h) === -1; }))); } catch (e) {}
        header();
      }
    });
  }
  document.addEventListener('bs:wishlist', renderPage);

  var timer;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(decorate, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });

  function start() { decorate(); sync(); renderPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  window.bsWishlist = { read: read, has: has, toggle: toggle };
})();
